/**
 * PaywallHeader - Header with dynamic message based on paywall context
 *
 * Displays appropriate messaging for different payment failure scenarios.
 */

/**
 * Context for determining paywall message display
 */
export interface PaywallContext {
  isTrial: boolean;
  isPaymentFailed: boolean;
  hasLabsProcessed: boolean;
}

export type PaywallReason = PaywallContext;

interface PaywallHeaderProps {
  reason: PaywallContext;
}

function getMessage(context: PaywallContext): string {
  const { isTrial, isPaymentFailed, hasLabsProcessed } = context;

  if (isPaymentFailed) {
    if (isTrial) {
      return "Your free trial has ended, and we couldn't process your payment. Update your payment to unlock your full results.";
    }
    return "Your payment couldn't be processed. Update your payment to continue your membership.";
  }

  // Cancelled scenarios
  if (hasLabsProcessed) {
    return 'Your membership has been cancelled. Resubscribe to unlock your full results.';
  }

  return 'Your membership has been cancelled. Resubscribe to continue your membership.';
}

export function PaywallHeader({ reason }: PaywallHeaderProps) {
  return (
    <div className="w-full">
      <p className="text-[28px] font-bold leading-[1.2] text-[#0A2540]">
        {getMessage(reason)}
      </p>
    </div>
  );
}
